import { gql } from '@apollo/client';

import { professorActivityAnswerFragment } from '../fragments';
import { ProfessorActivityAnswer } from '../../types';

export interface CreateActivityAnswerFeedbackMutationVariables {
  courseId: string;
  activityId: string;
  answerId: string;
  input: { text?: string; file?: { name: string; path: string } };
}

export interface CreateActivityAnswerFeedbackMutationResult {
  answer: ProfessorActivityAnswer;
}

export const createActivityAnswerFeedbackMutation = gql`
  mutation CreateActivityAnswerFeedbackMutation(
    $courseId: String!
    $activityId: String!
    $answerId: String!
    $input: CreateActivityAnswerFeedbackMutationInput!
  ) {
    answer(courseId: $courseId, activityId: $activityId, answerId: $answerId, input: $input)
      @rest(type: "ActivityAnswer", path: "courses/{args.courseId}/activities/{args.activityId}/answers/{args.answerId}/feedback", method: "POST") {
      ...ProfessorActivityAnswer
    }
  }
  ${professorActivityAnswerFragment}
`;
